import { Button, Divider, Menu, Spin, Typography } from 'antd';
import Table, { ColumnsType } from 'antd/lib/table';
import { useEffect, useState } from 'react';
import SearchTable from '../../Shared/Table/searchTable';
import { useHistory } from 'react-router-dom';
import '../../../../styles/pages/warehouse/_inbound/_index.scss';
import inboundService from '../service/inbound';
import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import useDebounce from '@root/core/hooks/useDebounce';

interface DataTypeWare {
  id: any;
  name: string;
  email: string;
  productName: string;
  quantity: number;
  status: string;
  updatedAt: string;
}

interface labelSelect {
  key: string;
  label: string;
}
interface menu {
  id: number;
  titleSelect: string;
  list: JSX.Element;
}
function TableInbound() {
  const [labelSelect, setLabelSelect] = useState<labelSelect>({
    key: '1',
    label: 'Select'
  });
  const [filterDateFrom, setFilterDateFrom] = useState<string>();
  const [filterDateTo, setFilterDateTo] = useState<string>();
  const [searchBy, setSearchBy] = useState<string>('');
  const [valueSearch, setValueSearch] = useState<string>('');
  const fromDt: string = filterDateFrom || '';
  const toDt: string = filterDateTo || '';
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sort, setSort] = useState(true);
  const debounce = useDebounce(valueSearch, 1000);

  const [listExcel, setlistExcel] = useState<React.Key[]>([]);
  const { Text } = Typography;

  const history = useHistory();

  const onSelectChange = (selectedRowKeys: React.Key[]) => {
    setlistExcel(selectedRowKeys);
  };
  const rowSelection = {
    listExcel,
    onChange: onSelectChange,
    preserveSelectedRowKeys: true
  };

  const hasSelected = listExcel.length > 0;

  // Handle seach table
  const getSelect = (e: any) => {
    setSearchBy(e.key);
    setLabelSelect({ key: e.key, label: e.domEvent.target.innerText });
  };
  const menu: menu[] = [
    {
      id: 1,
      titleSelect: 'Select',
      list: (
        <Menu
          onClick={getSelect}
          items={[
            {
              label: 'Seller Name',
              key: 'name'
            },
            {
              label: 'Product Name',
              key: 'productName'
            }
          ]}
        />
      )
    }
  ];

  const getDate = (startDate: string, endDate: string) => {
    setFilterDateFrom(startDate);
    setFilterDateTo(endDate);
    setCurrentPage(1);
  };

  const getText = (text: string) => {
    setValueSearch(text);
  };

  // handle get List Inbound
  const { handleListInbound } = useActions();
  useEffect(() => {
    if (currentPage === 1) {
      handleListInbound(currentPage, sort, fromDt, toDt, searchBy, debounce);
    } else {
      setCurrentPage(1);
    }
  }, [fromDt, toDt, sort, searchBy, debounce]);

  const SearchName = () => {};

  const { data, error, loading } = useTypedSelector(
    (state) => state.inboundReducer
  );
  const dataSource = data?.rowData?.map((item: DataTypeWare, index: number) => {
    return {
      id: <Text>{item.id}</Text>,
      name: <Text>{item.name}</Text>,
      email: <Text>{item.email}</Text>,
      productName: <Text>{item.productName}</Text>,
      quantity: <Text>{item.quantity === 0 ? '00' : item.quantity}</Text>,
      status: <Text>{item.status}</Text>,
      updatedAt: <Text>{item.updatedAt}</Text>
    };
  });

  const columns: ColumnsType<DataTypeWare> = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Seller name',
      dataIndex: 'name'
    },
    {
      title: 'Seller E-mail Address ',
      dataIndex: 'email'
    },
    {
      title: 'Product name',
      dataIndex: 'productName'
    },
    {
      title: 'Quantity ',
      dataIndex: 'quantity'
    },

    {
      title: 'Status',
      dataIndex: 'status'
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          Update Date
          {!sort ? (
            <UpOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(true);
                setCurrentPage(1);
              }}
            />
          ) : (
            <DownOutlined
              style={{ marginLeft: '15px' }}
              onClick={() => {
                setSort(false);
                setCurrentPage(1);
              }}
            />
          )}
        </div>
      ),
      dataIndex: 'updatedAt'
    }
  ];
  // handle download
  const idMap = listExcel.map((item: React.Key) => item);

  const arrId = {
    ids: idMap
  };
  const handleDownload = async () => {
    if (listExcel.length === 0) {
      const resp = await inboundService.exportExcel({
        currentPage,
        sort,
        fromDt,
        toDt,
        searchBy,
        valueSearch
      });
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Inbound_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([resp]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await inboundService.postDownloadExcelId(arrId);
      const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      const outputFilename = `Inbound_ ` + utc + `.xlsx`;
      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };

  return (
    <>
      <div className="spin">{loading && <Spin />}</div>

      <div className="wrapTableList">
        <SearchTable
          labelSelect={labelSelect}
          getDate={getDate}
          searchText={getText}
          onSearchName={SearchName}
          menu={menu}
        />

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '15px 17px',
            background: 'white',
            alignItems: 'center'
          }}
        >
          <div>
            <span style={{ marginLeft: 8, marginRight: 8 }}>
              Total Inbound {data.count}
            </span>
            <Divider type="vertical" />
            <span style={{ marginLeft: 8 }}>
              Select Inbound {hasSelected ? ` ${listExcel.length}` : '00'}
            </span>
          </div>

          <div>
            <Button className="downExcel" onClick={handleDownload}>
              Download Excel
            </Button>
          </div>
        </div>
        <Table
          rowKey={(record) => record.id.props.children}
          className="tableInbound warehouse-table"
          columns={columns}
          pagination={{
            pageSize: 10,
            total: data.count,
            current: currentPage,
            onChange: (currentPage) => {
              setCurrentPage(currentPage);
              handleListInbound(
                currentPage,
                sort,
                fromDt,
                toDt,
                searchBy,
                valueSearch
              );
            }
          }}
          rowSelection={rowSelection}
          dataSource={dataSource}
          onRow={(record) => {
            return {
              onClick: () => {
                history.push(`/admin/inbound/${record.id.props.children}`);
              }
            };
          }}
        />
      </div>
    </>
  );
}
export default TableInbound;
